import { SerializePayload } from 'app/area/search-filters/types';
import { filterId } from './constants';
import { ExternalUrlsSearchModel } from './types-store';

const serializeQuery = (query: string) =>
  query?.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};

export const serialize = (payload: SerializePayload): ExternalUrlsSearchModel => serializeQuery(payload.query);
